export default {
  id: 86,
  title: 'Target #86 - Stairway',
  url: 'https://cssbattle.dev/play/86',
  colors: ['#191919', '#4F77FF'],
  solution:
    '<a a><a b><style>[a],[b]{width:100}[b],body{background:#191919}a{position:fixed}[a]{top:75;left:150;height:150;background:#4f77ff;border-radius:9in 9in 0 0}[b]{top:205;left:170;height:20;box-shadow:20px -24px #191919,40px -48px #191919,60px -72px #191919}</style>',
}
